module.exports = __webpack_public_path__ + "img/btn_bg@2x.8169188.png";